import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrders } from "../../../redux/slices/orders";
import { Card, Button, Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import Order from "./Order";
import Loader from "../../../components/spinners/Loader";
import OrderModal from "./modals/OrderModal";
import NotyfContext from "../../../contexts/NotyfContext";
import { useTranslation } from "react-i18next";
import OrderInformationModal from "./modals/OrderInformationModal";

const Lane = ({ name, children, showOrderModal, setShowOrderModal, user }) => {
  const { t } = useTranslation();
  const whitelabel = useSelector((state) => state.whitelabel.whitelabel);
  const [showAllOrders, setShowAllOrders] = useState(false);
  const displayedOrders = showAllOrders ? children : children.slice(0, 5);

  return (
    <Card>
      <Card.Header>
        <Card.Title>{name}</Card.Title>
      </Card.Header>
      <Card.Body>
        {/* <div>
          {children && children.length > 0 ? children : t("orders.noOrders")}
        </div>
        <div className="d-grid">
          {children && children.length > 0 && (
            <Button
              style={{
                "--dynamic-bg-color": whitelabel?.backgroundColor ?? "#0E1A2B",
                "--dynamic-font-color": whitelabel?.fontColor ?? "#ffffff",
                border: "none",
              }}
              onClick={() => setShowOrderModal(true)}
            >
              {t("orders.showAllOrders")}
            </Button>
          )}
        </div> */}
        <div
          style={{
            maxHeight: showAllOrders ? "500px" : "250px", // Expand when clicked
            overflowY: "auto",
            transition: "max-height 0.3s ease-in-out",
          }}
        >
          {displayedOrders && displayedOrders.length > 0
            ? displayedOrders
            : t("orders.noOrders")}
        </div>
        <div className="d-grid mt-2">
          {children && children.length > 5 && (
            <Button
              style={{
                "--dynamic-bg-color": whitelabel?.backgroundColor ?? "#0E1A2B",
                "--dynamic-font-color": whitelabel?.fontColor ?? "#ffffff",
                border: "none",
              }}
              onClick={() => setShowAllOrders((prev) => !prev)}
            >
              {showAllOrders ? t("orders.showLess") : t("orders.showAllOrders")}
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

const Orders = ({ demoMode = false }) => {
  const { t } = useTranslation();
  const { orders } = useSelector((state) => state.orders);
  const [openOrders, setOpenOrders] = useState([]);
  const [parkedOrders, setParkedOrders] = useState([]);
  const [finishedOrders, setFinishedOrders] = useState([]);
  const [errorOrders, setErrorOrders] = useState([]);
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);
  const [activeUser, setActiveUser] = useState({});
  const whitelabel = useSelector((state) => state.whitelabel.whitelabel);
  const notyf = useContext(NotyfContext);
  const isDemoOrLead = demoMode || activeUser.role === "lead";
  const [isLoading, setIsLoading] = useState(!isDemoOrLead);
  const [showOpenOrderModal, setShowOpenOrderModal] = useState(false);
  const [showErrorOrderModal, setShowErrorOrderModal] = useState(false);
  const [showFinishedOrderModal, setShowFinishedOrderModal] = useState(false);
  const [showParkedOrderModal, setShowParkedOrderModal] = useState(false);
  const dispatch = useDispatch();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showInfoModal, setShowInfoModal] = useState(false);

  useEffect(() => {
    setIsLoading(!isDemoOrLead);
  }, [isDemoOrLead]);

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [impersonationUser, user]);

  useEffect(() => {
    const fetchOrders = async () => {
      await Promise.all([dispatch(getOrders())])
        .catch((error) => {
          notyf.open({
            type: "danger",
            message: error,
            duration: 5000,
            dismissible: false,
            ripple: true,
            position: {
              x: "center",
              y: "top",
            },
          });
        })
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, [500]);
        });
    };

    if (activeUser.id && !isDemoOrLead) {
      fetchOrders();
    }
  }, [dispatch, activeUser]);

  const demoOrders = [
    {
      id: 100001,
      name: "TerminateSimOrder",
      status: "Done",
      type: "TerminateSimOrder",
      created_by: "emily.nash@iotconnect.net",
      creationDate: "15/07/2025 09:30",
      lastUpdateDate: "15/07/2025 09:31",
      sims: Array.from({ length: 10 }, (_, i) => ({
        id: 47000 + i,
        iccid: "8988********" + (1000 + i),
        imsi: "9014********" + (1000 + i),
        msisdn: "+4477******" + (1000 + i),
      })),
    },
    {
      id: 100002,
      name: "ActivateSimOrder",
      status: "Open",
      type: "ActivateSimOrder",
      created_by: "liam.connor@demo-m2m.org",
      creationDate: "16/07/2025 14:12",
      lastUpdateDate: "16/07/2025 14:15",
      sims: Array.from({ length: 5 }, (_, i) => ({
        id: 48000 + i,
        iccid: "8944********" + (2000 + i),
        imsi: "2345********" + (2000 + i),
        msisdn: "+3069******" + (2000 + i),
      })),
    },
    {
      id: 100003,
      name: "ModifySimOrder",
      status: "Error",
      type: "ModifySimOrder",
      created_by: "mia.larsson@globaliot.test",
      creationDate: "17/07/2025 11:47",
      lastUpdateDate: "17/07/2025 11:49",
      sims: Array.from({ length: 3 }, (_, i) => ({
        id: 49000 + i,
        iccid:
          i % 2 === 0
            ? "8944********" + (3000 + i)
            : "8988********" + (3000 + i),
        imsi:
          i % 2 === 0
            ? "2345********" + (3000 + i)
            : "9014********" + (3000 + i),
        msisdn:
          i % 2 === 0 ? "+3934******" + (3000 + i) : "+3519******" + (3000 + i),
      })),
    },
  ];

  useEffect(() => {
    if (!isDemoOrLead) {
      const open = orders.filter((order) => order.status === "Pending");
      const parked = orders.filter((order) => order.status === "Parked");
      const finished = orders.filter((order) => order.status === "Done");
      const error = orders.filter((order) => order.status === "Error");
      setOpenOrders(open);
      setParkedOrders(parked);
      setFinishedOrders(finished);
      setErrorOrders(error);
    } else {
      const open = demoOrders.filter((order) => order.status === "Pending");
      const parked = demoOrders.filter((order) => order.status === "Parked");
      const finished = demoOrders.filter((order) => order.status === "Done");
      const error = demoOrders.filter((order) => order.status === "Error");
      setOpenOrders(open);
      setParkedOrders(parked);
      setFinishedOrders(finished);
      setErrorOrders(error);
    }
  }, [orders, isDemoOrLead]);

  if (!isLoading) {
    return (
      <React.Fragment>
        <Helmet title="Orders" />
        <Container fluid className="p-0">
          <h1 className="h3 mb-3">{t("orders.title")}</h1>
          <Row>
            <Col lg="6">
              <Lane
                name={t("orders.open")}
                showOrderModal={showOpenOrderModal}
                setShowOrderModal={setShowOpenOrderModal}
                user={impersonationUser.id ? impersonationUser : user}
              >
                {openOrders.map((order) => (
                  <Order
                    key={order.id}
                    order={order}
                    demoMode={demoMode}
                    setShowInfoModal={setShowInfoModal}
                    setSelectedOrder={setSelectedOrder}
                  />
                ))}
              </Lane>
              <OrderModal
                showOrderModal={showOpenOrderModal}
                setShowOrderModal={setShowOpenOrderModal}
                orders={openOrders}
              />
            </Col>
            <Col lg="6">
              <Lane
                name={t("orders.parked")}
                showOrderModal={showParkedOrderModal}
                setShowOrderModal={setShowParkedOrderModal}
                user={impersonationUser.id ? impersonationUser : user}
              >
                {parkedOrders.map((order) => (
                  <Order
                    key={order.id}
                    order={order}
                    demoMode={demoMode}
                    setShowInfoModal={setShowInfoModal}
                    setSelectedOrder={setSelectedOrder}
                  />
                ))}
              </Lane>
              <OrderModal
                showOrderModal={showParkedOrderModal}
                setShowOrderModal={setShowParkedOrderModal}
                orders={parkedOrders}
              />
            </Col>
            <Col lg="6">
              <Lane
                name={t("orders.finished")}
                showOrderModal={showFinishedOrderModal}
                setShowOrderModal={setShowFinishedOrderModal}
                user={impersonationUser.id ? impersonationUser : user}
              >
                {finishedOrders.map((order) => (
                  <Order
                    key={order.id}
                    order={order}
                    demoMode={demoMode}
                    setShowInfoModal={setShowInfoModal}
                    setSelectedOrder={setSelectedOrder}
                  />
                ))}
              </Lane>
              <OrderModal
                showOrderModal={showFinishedOrderModal}
                setShowOrderModal={setShowFinishedOrderModal}
                orders={finishedOrders}
              />
            </Col>
            <Col lg="6">
              <Lane
                name={t("orders.error")}
                showOrderModal={showErrorOrderModal}
                setShowOrderModal={setShowErrorOrderModal}
                user={impersonationUser.id ? impersonationUser : user}
              >
                {errorOrders.map((order) => (
                  <Order
                    key={order.id}
                    order={order}
                    demoMode={demoMode}
                    setShowInfoModal={setShowInfoModal}
                    setSelectedOrder={setSelectedOrder}
                  />
                ))}
              </Lane>
              <OrderModal
                showOrderModal={showErrorOrderModal}
                setShowOrderModal={setShowErrorOrderModal}
                orders={errorOrders}
              />
            </Col>
          </Row>
          {selectedOrder && (
            <OrderInformationModal
              showInfoModal={showInfoModal}
              setShowInfoModal={setShowInfoModal}
              orderId={selectedOrder}
              demoMode={demoMode}
            />
          )}
        </Container>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Helmet title="Orders" />
        <Container fluid className="p-0 w-100 h-100">
          <Card className="w-100 h-100">
            <Card.Body>
              <Loader />
            </Card.Body>
          </Card>
        </Container>
      </React.Fragment>
    );
  }
};

export default Orders;
